(function (Drupal, $) {
  Drupal.behaviors.toggle = {
    attach: function attach(context) {
      $(context).find("[data-toggle]").click(function () {
        const target = $(this).attr('data-toggle-target');
        $(target).toggleClass($(this).attr('data-toggle'));
      });
    }
  };
})(Drupal, jQuery);
